import { createApp } from 'vue'

import App from './App.vue'
import { apolloPlugin } from './plugins/apollo'
import dropzone from './plugins/dropzone'
import { pinia } from './plugins/pinia'
import router from './plugins/router'
import sentry from './plugins/sentry'
import vCalendar from './plugins/v-calendar'
import vuetify from './plugins/vuetify'

const app = createApp(App)
dropzone(app)
sentry(app, router)
vCalendar(app)

app
  .use(apolloPlugin)
  .use(pinia)
  .use(router)
  .use(vuetify)
  .mount('#app')
